import React from 'react';
import moment from 'moment';
// @ts-ignore
import styles from './DrMaxPharmacyWorkingHours.module.scss';
import { DrMaxOpeningHour, DrMaxOpeningHourItem } from '../../../../graphql/graphql';
import useTranslation from '../../../../Hooks/useTranslation';
import { joinClasses } from '../../../../Utils/className.util';

const dayTranslations: Record<number, string> = {
	0: 'base.weekDays.monday',
	1: 'base.weekDays.tuesday',
	2: 'base.weekDays.wednesday',
	3: 'base.weekDays.thursday',
	4: 'base.weekDays.friday',
	5: 'base.weekDays.saturday',
	6: 'base.weekDays.sunday'
}

interface Props {
	openingHours: DrMaxOpeningHourItem[];
	inReservation?: boolean;
}

const DrMaxPharmacyWorkingHours: React.FC<Props> = ({ openingHours, inReservation= false }) => {
	const { t } = useTranslation();
	return (
		<div className={joinClasses([styles.wrapper, inReservation ? styles.wrapperCenter : undefined])}>
			<div className={styles.title}>
				{t('base.openingHours')}:
			</div>
			<div className={joinClasses([styles.content, inReservation ? styles.noPadding : undefined])}>
				{openingHours?.map((item) =>
					<div className={joinClasses([styles.item, inReservation ? styles.center : undefined])}>
						<div className={styles.label}>{t(dayTranslations[moment(item.date).weekday()])}</div>
						<div className={styles.value}>{item?.hours?.map((hour) => {
							if (hour?.open) {
								return moment(hour?.from).format('HH:mm') + '-' + moment(hour?.to).format('HH:mm') + ' ';
							}
							return t('base.closed');
						})}</div>
					</div>,
				)}
			</div>
		</div>
	);
};

export default DrMaxPharmacyWorkingHours;